import { SignJWT, EncryptJWT, jwtDecrypt, jwtVerify } from "jose";
import { Buffer } from "buffer";

export const generateJWTAndSecret = async (object) => {
  var buffer = new Buffer.alloc(1000);
crypto.getRandomValues(buffer);
const jwt = await new SignJWT({key: object})
  .setProtectedHeader({ alg: "HS256" })
  .setIssuedAt()
  .setExpirationTime("5min")
  .sign(buffer);
return {jwt, secret: encodeURIComponent(Buffer.from(buffer).toString("base64"))};
}

export const decryptJWT = async (object, key) => {
const {payload} = await jwtDecrypt(object,key);
return {payload};
}

export const decodeJWT = async (object, key) => {
const {payload} = await jwtVerify(object,key);
return {payload};
}

export const encryptJWTWithKey = async (object, key) => {
  console.log(object);
const jwt = await new EncryptJWT(object)
  .setProtectedHeader({ alg: "RSA-OAEP", enc: "A256GCM" })
  .setIssuedAt()
  .setExpirationTime("5min")
  .encrypt(key);
return {jwt};
}
